'use client'

import {
  InlineLink,
  QuietLink,
  SectionHead,
  useReveal,
} from '@/components/page-kit'
import { MarginList, MarginRow } from './margin-list'
import { LMS } from './data'

/* The eight authored capability lines, verbatim, on the margin rule. No
   checkmark icons.

   "What's included" is a structural label, not a claim. */

export function LmsIncluded() {
  const list = useReveal<HTMLDivElement>(0.1)

  return (
    <section id="included" className="scroll-mt-24 pt-16 sm:pt-20 md:pt-28">
      <div className="container mx-auto">
        <SectionHead
          eyebrow="Scope"
          title="What's included."
          action={
            <QuietLink href="/product-brochure">
              Download the brochure
            </QuietLink>
          }
        />

        <div ref={list.ref} className="mt-10 sm:mt-12">
          <MarginList shown={list.shown}>
            {LMS.capabilities.map((c, i) => (
              <MarginRow
                key={c}
                index={i}
                shown={list.shown}
                className="py-4 sm:py-5"
              >
                <p className="font-heading text-base font-normal leading-snug text-foreground sm:text-lg">
                  {c}
                </p>
              </MarginRow>
            ))}
          </MarginList>
        </div>

        {/* Same capability, read from the school's side of the platform. */}
        <p className="mt-8 max-w-2xl text-sm leading-relaxed text-muted-foreground sm:text-base">
          Schools get this as the{' '}
          <InlineLink href="/schoolerp/features/lms">
            digital classroom module
          </InlineLink>
          , with marks and report cards handled next door by the{' '}
          <InlineLink href="/schoolerp/features/examination-results">
            examination and results module
          </InlineLink>{' '}
          in <InlineLink href="/schoolerp">Euclideum School ERP</InlineLink>.
        </p>
      </div>
    </section>
  )
}
